import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function StickyCTA({ brand, label = "Browse Menu" }) {
    return (
        <Link
            to="/menu/queens-long-island"
            data-testid="sticky-shop-cta"
            className="fixed bottom-6 left-1/2 -translate-x-1/2 md:left-auto md:right-8 md:translate-x-0 z-40 inline-flex items-center gap-2 bg-zen-olive text-zen-bg hover:bg-zen-olive-dark px-6 py-4 font-medium uppercase tracking-[0.22em] text-[11px] transition-all shadow-[0_10px_30px_rgba(31,36,24,0.18)]"
        >
            {label}
            <ArrowUpRight size={14} strokeWidth={2.4} />
        </Link>
    );
}
